import { Component } from 'react';
import { Link } from 'react-router-dom';
import IgniteDataTable from '../../../../common/datatable';
import { history } from '../../../../../store';

class DuplicateScanList extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        prop: 'created_at',
        title: 'Scan date'
      },
      {
        prop: 'customer_number',
        title: 'Customer number'
      },
      {
        prop: 'user_id',
        title: 'User ID',
        format(data, row) {
          const userEditPath = row.is_owner_or_staff ? 'details' : 'edit';

          return <Link to={`/admin/users/${data}/${userEditPath}`}>{data}</Link>;
        }
      },
      {
        prop: 'valid_scan',
        title: 'Valid'
      },
      {
        prop: 'fail_reason',
        title: 'Fail reason'
      }
    ];

    this.actions = [
      {
        label: 'View scan',
        callback: (row) => {
          history.push(`/admin/scans/${row.id}`);
          history.go(0);
        }
      }
    ];
  }

  render() {
    const { duplicateScans } = this.props;

    return (
      <IgniteDataTable
        columns={this.columns}
        actions={this.actions}
        data={duplicateScans}
        hasAttributes={false}
        hideId={false}
        inlineActions
      />
    );
  }
}

export default DuplicateScanList;
